/**
 * An enumeration of notification types.
 * @enum {string}
 */
export enum NotificationType {
  /**
   * success notification
   */
  SUCCESS='success',

  /**
   * error notification
   */
  ERROR='error',
  /**
   * information notification
   */
  INFO='info',
  /**
   * warning notification
   */
  WARNING='warning',
}
